<template>
  <div class="massaction-confirm-modal">
    <template v-if="action_ids.indexOf(3) >= 0 && action_ids.indexOf(4) >= 0">
      <div class="confirm-modal-title">
        {{ $tc("signInOut.signedInOut", 1) }}
      </div>
      <div
        class="confirm-modal-body"
        :style="{marginBottom: kioskName ? '24px': '40px'}"
        v-html="
          $tc('signInOut.signedInOut', 2, {
            'site-area': `${this.site_name} - ${this.area_name}`,
          })
        "
      />

      <div
        v-if="kioskName"
        style="margin-top: 0"
        class="confirm-modal-body"
        v-html="$t('signInOut.checkKiosk', { 'kioskName': kioskName })"
      />

    </template>

    <template v-else-if="action_ids.indexOf(1) >= 0">
      <div class="confirm-modal-title">{{ $tc("signInOut.checkedIn", 1) }}</div>
      <div
        class="confirm-modal-body"
        :style="{marginBottom: kioskName ? '24px': '40px'}"
        v-html="
          $tc('signInOut.checkedIn', 2, {
            'site-area': `${this.site_name} - ${this.area_name}`,
          })
        "
      />

      <div
        v-if="kioskName"
        style="margin-top: 0"
        class="confirm-modal-body"
        v-html="$t('signInOut.checkKiosk', { 'kioskName': kioskName })"
      />
    </template>

    <template v-else-if="action_ids.indexOf(3) >= 0">
      <div class="confirm-modal-title">{{ $tc("signInOut.userSignedIn",1) }}</div>
      <div
        class="confirm-modal-body"
        :style="{marginBottom: kioskName ? '24px': '40px'}"
        v-html="
          $tc('signInOut.userSignedIn', 2, {
            'site-area': `${this.site_name} - ${this.area_name}`,
          })
        "
      />

      <div
        v-if="kioskName"
        style="margin-top: 0"
        class="confirm-modal-body"
        v-html="$t('signInOut.checkKiosk', { 'kioskName': kioskName })"
      />
    </template>

    <template v-else-if="action_ids.indexOf(4) >= 0">
      <div class="confirm-modal-title">
        {{ $tc("signInOut.userSignedOut", 1) }}
      </div>
      <div
        class="confirm-modal-body"
        :style="{marginBottom: kioskName ? '24px': '40px'}"
        v-html="
          $tc('signInOut.userSignedOut', 2, {
            'site-area': `${this.site_name} - ${this.area_name}`,
          })
        "
      />

      <div
        v-if="kioskName"
        style="margin-top: 0"
        class="confirm-modal-body"
        v-html="$t('signInOut.checkKiosk', { 'kioskName': kioskName })"
      />
    </template>
    <hr class="confirm-modal-divider" />
    <button @click="redirectToDashboard" class="confirm-modal-btn">
      {{ $t("common.okay") }}
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      modalTitle: "",
      modalBody: "",
      area_name: "",
      site_name: "",
      kioskName: null,
      action_ids: [],
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    redirectToDashboard() {
      window.location.href = "/";
      this.$bvModal.hide("redirectModal");
    },
  },
  beforeMount() {
    this.site_name = this.getModalInfo.site_name;
    this.area_name = this.getModalInfo.area_name;
    this.kioskName = this.getModalInfo.kioskName;
    this.action_ids = this.getModalInfo.result?.map((result) =>
      parseInt(result)
    );
  },
};
</script>

<style lang="scss">
.massaction-confirm-modal {
  .confirm-modal-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
  }
  .confirm-modal-body {
    color: #4A4A4A;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
    margin: 40px 0;
  }
  .confirm-modal-btn {
    background-color: #103f5e;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    border: 0;
    border-radius: 24px;
    width: 112px;
    height: 33px;
    margin-top: 20px;
    margin-inline-start: 145px;
  }
  .confirm-modal-divider {
    margin: 0;
  }
}
</style>
